import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f3afac8a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3afac8a')) {
      api.createRecord('f3afac8a', component.options)
    } else {
      api.reload('f3afac8a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f3afac8a&", function () {
      api.rerender('f3afac8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221WAjsK73v1i/JS/comp/FavElement.vue"
export default component.exports